// TODO: Update session storage to hide by ID

import $ from 'jquery';
import BaseComponent from 'components/BaseComponent';

export default class NotificationComponent extends BaseComponent {
    constructor($element, options) {
        super($element, options);

        this.init();
    }

    static defaults = {
    }

    SELECTOR = {
        MESSAGE: '[data-notification]',
        DISMISS: '[data-notification-dismiss]',
    }

    STATE = {
        HIDDEN: 'u-isHidden',
    }

    /**
     * Binds the scope of any handler functions.
     * Should only be run on initialization of the view.
     *
     * @method setupHandlers
     * @returns {NotificationComponent}
     * @private
     */
    setupHandlers() {
        // Bind event handlers scope here
        this.onDismissClickHander = this.onDismissClick.bind(this);

        return this;
    }

    /**
     * Create any child objects or references to DOM elements.
     * Should only be run on initialization of the view.
     *
     * @method createChildren
     * @returns {NotificationComponent}
     * @private
     */
    createChildren() {
        super.createChildren();

        this.$dismiss = this.$element.find(this.SELECTOR.DISMISS);

        return this;
    }

    /**
     * Remove any child objects or references to DOM elements.
     *
     * @method removeChildren
     * @returns {NotificationComponent}
     * @public
     */
    removeChildren() {
        super.removeChildren();

        return this;
    }

    /**
     * Kicks off initial layout functionality needed.
     *
     * @method layout
     * @returns {NotificationComponent}
     * @public
     */
    layout() {
        super.layout();

        this.loadNotificationState();

        const notifications = document.querySelectorAll(this.SELECTOR.MESSAGE);

        for (let i = 0; i < notifications.length; i++) {
            const node = notifications[i];
            const id = node.getAttribute('data-notification');
            if (this.dismissedNotifications.indexOf(id) === -1) {
                $(node).show();
            }
        };

        return this;
    }

    /**
     * Enables the component.
     * Performs any event binding to handlers.
     * Exits early if it is already enabled.
     *
     * @method enable
     * @returns {NotificationComponent}
     * @public
     */
    enable() {
        if (this.isEnabled) {
            return this;
        }
        this.isEnabled = true;

        this.$dismiss.on('click', this.onDismissClickHander);

        return this;
    }

    /**
     * Disables the component.
     * Tears down any event binding to handlers.
     * Exits early if it is already disabled.
     *
     * @method disable
     * @returns {NotificationComponent}
     * @public
     */
    disable() {
        if (!this.isEnabled) {
            return this;
        }
        this.isEnabled = false;


        return this;
    }

    /*
        EVENT HANDLERS
    */
    onDismissClick(e) {
        const dismissedId = $(e.currentTarget).data('notificationDismiss');
        this.storeNotificationState(dismissedId);
    }

    /**
     * Hides the global notification element.
     * Sets dismissed notification to session storage
     *
     * @method hideNotification
     * @param {Number} dismissedId
     * @public
     */
    storeNotificationState(dismissedId) {
        this.loadNotificationState();

        this.dismissedNotifications.push(dismissedId);
        const dismissedNotificationIDs = this.dismissedNotifications.join(',');
        try {
            sessionStorage.setItem('dismissedNotifications', dismissedNotificationIDs);
        } catch (e) {
            // Catch iOS Safari 10 bug with local storage in private mode
            // https://stackoverflow.com/questions/18860098/on-a-browser-sessionstorage-in-safaris-private-browsing-does-not-work-the-same
            if (e.toString().indexOf('QuotaExceededError') === -1) {
                throw e;
            }
        }

        this.dismissNotification(dismissedId);
    }

    /**
     * Called on load to retrieve any dismissed notifications from session storage.
     */
    loadNotificationState() {
        const notificationsFromStorage = sessionStorage.getItem('dismissedNotifications');

        if (notificationsFromStorage) {
            this.dismissedNotifications = notificationsFromStorage.split(',');
        } else {
            this.dismissedNotifications = [];
        }
    }

    dismissNotification(notificationToHide) {
        const notification = $(`[data-notification=${notificationToHide}]`);

        notification.slideUp('150', () => {
            notification.hide();
        });
    }
}
